import { USER_TRACK_EVENTS } from "@/store/modules/user/consts";

/**
 * Posts to POST /addActivity (Mongo ActivityLogs).
 * Uses dynamic import to avoid circular dependency (store → actions → main → activityLogContext).
 * @param {{ current: string, activity: string, next?: string, meta?: object, merchantId?: string }} data
 */
export async function logEvent(data) {
  const meta = {
    ...(data.meta || {}),
    pathname: window.location.pathname,
  };
  try {
    const { default: store } = await import("@/store");
    await store.dispatch(`user/${USER_TRACK_EVENTS}`, {
      moduleInfo: {
        current: data.current,
        activity: data.activity,
        next: data.next,
        meta,
        ...(data.merchantId ? { merchantId: data.merchantId } : {}),
      },
    });
  } catch (err) {
    console.debug("[activityLog] /addActivity failed", err);
  }
}
